export default function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}



// WEBPACK FOOTER //
// ./app/services/get-display-name.js